import { render, staticRenderFns } from "./TimeOffReportModal.vue?vue&type=template&id=2a537be6"
import script from "./TimeOffReportModal.vue?vue&type=script&lang=js"
export * from "./TimeOffReportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports